import { css } from "lit";

export const styles = css`
  :host {
    display: contents;
  }

  @keyframes flourish {
    0% {
      transform: scale(1);
      background-color: transparent;
    }
    50% {
      transform: scale(1.05);
      background-color: rgb(0 123 255 / 0.1);
    }
    100% {
      transform: scale(1);
      background-color: transparent;
    }
  }

  .link-card {
    border-radius: var(--sds-size-radius-400);
    border: 1px solid var(--sds-color-border-brand-default);
    background: var(--sds-color-background-default-tertiary);
    transition: all 0.2s ease;
    box-sizing: border-box;
  }

  .link-card-square {
    grid-column: span 1;
    aspect-ratio: 1;
    padding: 12px 8px;
    display: grid;
    grid-template:
      " dnd  header" auto
      " dnd  image " auto
      " dnd  title " 1fr
      " dnd  link  " auto
      / auto 1fr;
    gap: 8px;
  }

  .link-card-rectangular {
    padding: 12px 16px 12px 8px;
    display: grid;
    grid-template:
      " dnd  title header" auto
      " dnd  link  header" auto
      / auto 1fr auto;
    gap: 8px;
    grid-column: span 2;
    min-height: 60px;
    height: max-content;
  }

  .link-card-dnd-handle {
    grid-area: dnd;
    align-self: center;
    color: var(--sds-color-icon-neutral-tertiary);
    cursor: grab;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    min-height: 24px;
    min-width: 24px;
  }

  .link-card-header {
    grid-area: header;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .link-card-image {
    grid-area: image;
    display: flex;
    align-items: center;
  }

  .link-card-image img {
    width: 35px;
    height: 35px;
    border-radius: 4px;
    object-fit: cover;
  }

  .link-card-title {
    height: fit-content;
    grid-area: title;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .link-card-link {
    grid-area: link;
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Drag state styles */
  .link-card.dragging {
    opacity: 0.5;
    transform: scale(0.95);
    transition:
      opacity 0.2s ease,
      transform 0.2s ease;
  }

  /* Flourish effect */
  .link-card.flourish-active {
    animation: flourish 0.6s ease-out;
  }
`;
